import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import "../CSS/appointment.css"
import VehicleForm from "../Components/VehicleForm.js"
import Upgrade from "../Components/Upgrade.js"
import Package from "../Components/Package.js"
import CirclePlus from '../images/CirclePlus.svg'
import Modal from 'react-modal';
import SubscriptionService from '../utils/SubscriptionService.js';
import Sedan from '../images/spiffysedan.svg';
import NonSedan from '../images/nonsedan.svg';
//import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

import {
  BrowserRouter as Router,
  Link,
  Route // for later
} from 'react-router-dom'

export class Plans extends Component {
  constructor(props) {
    super(props)
    this.SubscriptionService = new SubscriptionService()
    this.state ={
      plans: [],
      width: document.body.clientWidth
    }
    this.updateDimensions = this.updateDimensions.bind(this)


  }
  componentDidMount() {
      window.addEventListener("resize", this.updateDimensions);
      var this_2 = this
      this.SubscriptionService.plans(this.props.vehicle.id)
      .then(res =>{
        if(res.subscriptions && res.subscriptions.length > 0){
          this.props.setError("")
          this.setState({
            plans: res.subscriptions
          })
          var plansHTML = []
          var this_2 = this
          this.state.plans.forEach(function(plan) {
            plansHTML.push(<li id={'plan'+plan.id}  onClick={() => this_2.props.selectPlan(plan)} className="plan list-group-item">
            <div className="twoColumn">
              <h6 className="halfDiv">{plan.name}</h6>
              <h6 className="halfDiv textAlignRight2">${plan.subscription_vehicle_types[0].amount/100}</h6>
            </div>{plan.frequency}</li> )
          });
          this.setState({
            plansHTML: plansHTML
          })
        }
        else {
          this.props.setError("Could not find packages. This may be caused by an invalid location or vehicle")
        }
      })
      .catch(err =>{
          alert(err);
      })
  }
  componentWillReceiveProps(){

  }
  componentWillUnmount() {
      window.removeEventListener("resize", this.updateDimensions);
  }
  savePlan(plan){
    this.props.savePlan(plan)
  }
  updateDimensions() {
      this.setState({width: document.body.clientWidth});
  }
  highlightChoice = (id) => {
    Array.from(document.getElementsByClassName("plan")).forEach(function(element, index, array) {
      element.style.backgroundColor = 'white'
    });
    if(document.getElementById("plan"+ id)){
      document.getElementById("plan"+ id).style.backgroundColor = "#ff8c00"
    }
  }

  componentWillMount = () => {

  }


  render() {
    const modalStyle =
    this.state.width < 780 ?
    {
      content: {
        top: '0%',
        left: '0%',
        right: '0%',
        backgroundColor: '#101E2C'
      }
    }:
    {
      content: {
        top: '0%',
        left: '15%',
        right: '15%',
        backgroundColor: '#101E2C'
      }
    }

    const customStyles = {
      content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        transform             : 'translate(-50%, -50%)'
      }
    };
    return (
      <div>
        <div className="modal-dialog">
          <div className="modal-content">
          <div className="modal-header">
            <center><h5 className="modal-title">Plans</h5></center>
          </div>
          <div className="modal-subtitle">
            <div className="card-title" id="accordion" role="tablist">
              {this.state.plansHTML}
            </div>
          </div>
      </div>
        </div>
      </div>
    )
  }
}
export default Plans



// WEBPACK FOOTER //
// ./src/Components/Plans.js